module.exports = __webpack_public_path__ + "static/img/3_1_6.bb849892.jpg";